"use client";

import { useMutation } from "@tanstack/react-query";
import type { SourcedWhere, TranscribeAudioResponse } from "@/generated/fastapi";
import { useAuth } from "@/state/globalStore";
import { transcribeAudio } from "../api/transcribeAudio";

interface TranscribeAudioInput {
  selectedFile: File;
  sourcedWhere: SourcedWhere;
}

export default function useTranscribeAudioMutation() {
  const { accessToken } = useAuth();

  return useMutation<TranscribeAudioResponse, Error, TranscribeAudioInput>({
    mutationFn: ({ selectedFile, sourcedWhere }) =>
      transcribeAudio(accessToken, sourcedWhere, selectedFile),
  });
}
